export default __webpack_public_path__ + "static/section3_feature3-25d0d937af2eef5a4f4826928e130d77.png";